import * as types from "../constants/LoginConstants";

const initialState = {
  token: localStorage.getItem("admintoken") || null,
  isLoading: false,
  error: null,
  isLoggedIn: !!localStorage.getItem("admintoken"),
};

const LoginReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOGIN_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        token: action.payload.token,
        isLoggedIn: true,
        error: null,
      };
    case types.LOGIN_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        isLoggedIn: false,
      };
    case types.LOGOUT:
      return { ...initialState, token: null, isLoggedIn: false };
    case types.RESET_AUTH_STATE:
      return { ...state, isLoading: false, error: null };
    default:
      return state;
  }
};

export default LoginReducer;
